import React, { useEffect, useState } from 'react';
import ChatCallCenterComponent from './ChatCallCenterComponent';
import { useChatContext } from 'pages/chats/ChatsContext';

const ChatCallCenterContainer = ({
  handleOnClickClose = () => null,
  onModal = false,
}) => {
  const {
    currentProposal,
    getCurrentDealerProducts,
    otherStates,
  }: any = useChatContext();

  const [
    onFetchCurrentDealerProducts,
    setFetchCurrentDealerProducts,
  ] = useState(false);

  useEffect(() => {
    getCurrentDealerProducts(setFetchCurrentDealerProducts);
  }, []);

  const handleOnClickBack = () => {
    window.history.back();
  };

  const isSearchAndRescue = window.location.pathname.includes(
    'busca-e-resgate'
  );

  const isQualified = window.location.search.includes('qualified');

  const viewComponentsProps = {
    handleOnClickBack,
    currentProposal,
    currentProposalStatus: isSearchAndRescue
      ? currentProposal?.searchAndRescueStatus
      : isQualified
      ? currentProposal?.status
      : currentProposal?.salesAssistantStatus,
    proposalError: otherStates.proposalError,
    handleOnClickClose,
    onModal,
    onFetchCurrentDealerProducts,
    vision: isQualified ? 'SHOWROOM' : 'CALLCENTER',
  };

  return <ChatCallCenterComponent {...viewComponentsProps} />;
};

export default ChatCallCenterContainer;
